import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { CheckCircle, FileText, Download } from "lucide-react";
export default function AuditReadyReporting() {
  const features = [{
    icon: FileText,
    title: "Clean Cheque Remittance Templates",
    description: "Professional, standardized templates that meet audit requirements and maintain brand consistency."
  }, {
    icon: CheckCircle,
    title: "Mapped Data Precision",
    description: "Every data point accurately mapped from GP to Business Central with full traceability."
  }, {
    icon: Download,
    title: "Branded Outputs",
    description: "All reports and documents carry your brand identity while meeting compliance standards."
  }];
  return <section className="bg-background py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="space-y-6 animate-fade-in-up">
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-foreground leading-snug tracking-tight">
              Audit-Ready Reporting
            </h2>
            <p className="text-foreground/80 text-lg leading-relaxed">
              Generate compliant, professional reports that satisfy auditors and stakeholders. Our migration framework ensures every transaction is traceable, mapped, and documented to the highest standards.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              <Button className="btn-primary shadow-medium hover:shadow-strong">
                <Link to="/ContactPage">
                  Request Demo
                </Link>
              </Button>
              <Button variant="outline" className="shadow-soft hover:shadow-medium">
                <Link to="/OurServicesPage">
                  View Features
                </Link>
              </Button>
            </div>
          </div>

          <div className="space-y-6 animate-fade-in-up-delay-100">
            <div className="bg-primary-light-background rounded-lg p-8 shadow-soft">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1409748/img/audit_reporting_dashboard.png" alt="Audit reporting dashboard" className="w-full rounded-md shadow-medium" />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-16 animate-fade-in-up-delay-200">
          {features.map((feature, i) => <Card key={i} data-index={i} className="card hover-lift">
              <CardHeader>
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-primary-light-background rounded-md">
                    <feature.icon className="size-6 text-primary" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-lg">{feature.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-foreground/70 leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}